import React, { Component } from 'react';

import { connect } from 'react-redux';

import * as Projects from 'projects/components';
import ProjectFormHandlers from 'projects/containers/ProjectFormHandlers';

import { getIsSaving, getIsFetching, getEditing, getIsFetchingConfig } from 'projects/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';

import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors'; //Groups
import { getVisibleGroups } from 'groups/selectors'; //Groups

class ProjectsFormContainer extends Component {
  render = () => (
    <ProjectFormHandlers
      render={({
        handleSubmit,
        handleValidation,
        handleValueChange,
        isSubmitted,
        handleGroupChange, //Groups
        handleCustomFieldChange, //Groups
        isSaving,
      }) => (
        <Projects.FormView
          company={this.props.company}
          project={this.props.project}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isFetching={this.props.isFetching}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={this.props.groups} //Groups
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          subcompany={this.props.subcompany}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  isFetchingConfig: getIsFetchingConfig(state),
  project: getEditing(state),
  company: getCompany(state),
  customfields: getVisibleCustomFieldsEmployees(state), //Groups
  groups: getVisibleGroups(state), //Groups
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(ProjectsFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/containers/ProjectFormContainer.js